import { viewsMap } from './viewsMap';

export const getSortedColorSketches = sketches => {
  const sketchesSorted = new Map([
    [viewsMap.FRONT, []],
    [viewsMap.INSIDE, []],
    [viewsMap.BACK, []],
    [viewsMap.OTHERS, []],
  ]);

  for (const sketch of Object.values(sketches || {})) {
    const key = sketch.name.replace(/[0-9]/g, '');

    if (sketchesSorted.has(key)) {
      sketchesSorted.get(key).push(sketch);
    } else {
      sketchesSorted.get(viewsMap.OTHERS).push(sketch);
    }
  }

  const output = [];

  for (const value of sketchesSorted.values()) {
    output.push(...value);
  }

  return output;
};
